import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { FormattedPrice } from '@libs/shop/models';
import { PricesFormatter } from '@libs/shared/services';

@Component({
  selector: 'ui-product-prices-formatter',
  templateUrl: './product-price-formatter.component.html',
  styleUrl: './product-price-formatter.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ProductPriceFormatterComponent {
  public pricesFormatter: PricesFormatter = inject(PricesFormatter);
  public price: InputSignal<number> = input.required();
  public showThousandthsPlace: InputSignal<boolean> = input(true);
  public alwaysPositiveNumber: InputSignal<boolean> = input(false);

  public formattedPrice: Signal<FormattedPrice> = computed(() => this.pricesFormatter.formatPrice(this.price(), this.alwaysPositiveNumber()));
}
